<template>
    <div class="report-tooltip" v-if="show">
        <div class="report-tooltip__button">Zobacz <IconPreview /></div>
        <div class="report-tooltip__content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import { IconPreview } from "@/components/ui/icons";

export default {
    name: "ReportListTooltip",
    components: {
        IconPreview,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss">

.report-tooltip {
    position: relative;
	margin: 0 5px;

    &:hover,
    &:focus,
    &:active {
        .report-tooltip__content {
            height: auto;
            width: 195px;
            padding: 10px;
            opacity: 1;
            overflow: unset;
        }
    }

	&__button {
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	&__content {
		position: absolute;
		transition: opacity 200ms;
		top: calc(100% + 10px);
		right: 0;
		width: 0;
		height: 0;
		background: #fff;
		color: #000000;
		border-radius: 10px;
		overflow: hidden;
		opacity: 0;
		font-size: 12px;
		filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));

		&:before {
			content: "";
			position: absolute;
			width: 15px;
			height: 15px;
			background: #fff;
			top: -5px;
			right: 30px;
			transform: rotate(45deg);
		}
	}
}

</style>